import logoDark from '@/assets/images/logo-dark.png'
import logoLight from '@/assets/images/logo-light.png'
import Loader from '@/components/Loader'
import IconifyIcon from '@/components/wrappers/IconifyIcon'
import { currentYear } from '@/context/constants'
import { ReactNode } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const AppLayout = ({
  children,
}: Readonly<{
  children: ReactNode
}>) => {
  return (
    <>
      <Loader />
      {children}
      <footer className="footer-part bg-dark py-5 pb-4">
        <Container>
          <Row className="mt-5 pb-5 justify-content-between g-3">
            <Col lg={3}>
            <div className="footer-about">
  <div className="logo mb-4">
    <Link className="logo text-uppercase" to="/">
      <img width={168} height={30} src={logoLight} alt="logoLight" className="logo-light" style={{ height: 30 }} />
      <img width={168} height={30} src={logoDark} alt="logoDark" className="logo-dark" style={{ height: 30 }} />
    </Link>
  </div>
  <p className="text-white mb-4">Sağlıklı yaşam, beslenme ve diyet konularındaki güncellemelerden haberdar olmak için bültenimize abone olun.</p>
  <Button variant="light" size="sm">
    Abone Ol
  </Button>
</div>
            </Col>




          </Row>
          <hr className="border-primary" />
          <Row className="align-items-center justify-content-between g-3">
            <Col lg={5}>
              <p className="m-0 fs-6 text-white-50">
                {currentYear} © Nazli Yegin - Design by ❤️{' '}
                <Link to="" className="text-white">
                  Justify Creative
                </Link>
              </p>
            </Col>
            <Col lg={4} className="text-lg-center">
              <ul className="d-flex gap-2 m-0 align-items-center justify-content-center">
                <li className="m-0">
                  <div className="icon d-flex rounded-circle align-items-center justify-content-center">
                    <Link to="https://www.youtube.com/@dytnazliyegin" className="text-dark f-18">
                      <IconifyIcon icon="tabler:brand-youtube" />
                    </Link>
                  </div>
                </li>
                <li className="m-0">
                  <div className="icon d-flex rounded-circle align-items-center justify-content-center">
                    <Link to="https://www.instagram.com/dytnazliyegin" className="text-dark f-18">
                      <IconifyIcon icon="tabler:brand-instagram" />
                    </Link>
                  </div>
                </li>
              </ul>
            </Col>
            <Col lg={3} className="text-lg-center">
              <Row className="g-3">
                <Col lg={6}>
                  <Link to="" className="text-white">
                    Kullanım Şartları
                  </Link>
                </Col>
                <Col lg={6}>
                  <Link to="" className="text-white">
                    Gizlilik Politikası
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  )
}

export default AppLayout
